import React from 'react';
import { FlaskConical, Presentation } from 'lucide-react';
import { useDbMode } from '@/context/DbModeContext';

export default function DevModeBanner() {
  const { dbMode, allowSwitch, demoMode, allowDemo } = useDbMode();

  const isDevActive = allowSwitch && dbMode === 'dev';
  const isDemoActive = allowDemo && demoMode === 'demo';

  if (!isDevActive && !isDemoActive) return null;

  if (isDemoActive) {
    return (
      <div
        style={{ zIndex: 99999 }}
        className="fixed bottom-5 right-5 flex items-center gap-2.5 px-4 py-2.5 rounded-full shadow-xl
                   bg-gray-900 border border-purple-500/60 text-purple-400
                   backdrop-blur-sm ring-1 ring-purple-500/20
                   animate-pulse-slow pointer-events-none select-none"
      >
        <Presentation size={14} className="flex-shrink-0 text-purple-400" />
        <span className="text-xs font-semibold tracking-wide uppercase whitespace-nowrap">
          Mode Démo
        </span>
        <span className="w-2 h-2 rounded-full bg-purple-400 shadow-[0_0_6px_2px_rgba(168,85,247,0.6)]" />
      </div>
    );
  }

  return (
    <div
      style={{ zIndex: 99999 }}
      className="fixed bottom-5 right-5 flex items-center gap-2.5 px-4 py-2.5 rounded-full shadow-xl
                 bg-gray-900 border border-orange-500/60 text-orange-400
                 backdrop-blur-sm ring-1 ring-orange-500/20
                 animate-pulse-slow pointer-events-none select-none"
    >
      <FlaskConical size={14} className="flex-shrink-0 text-orange-400" />
      <span className="text-xs font-semibold tracking-wide uppercase whitespace-nowrap">
        Base de données Dev
      </span>
      <span className="w-2 h-2 rounded-full bg-orange-400 shadow-[0_0_6px_2px_rgba(251,146,60,0.6)]" />
    </div>
  );
}
